import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Testimonial",
description: "A case study from TriRadial Solutions demonstrating how Freon powers a DSL for clinical research coordination. Highlights include custom Svelte integration, DSL-based clinical trial modeling, and use of the Freon interpreter framework.",
tags: [ "Freon", "testimonial", "TriRadial", "DSL", "clinical research", "CRC", "Svelte", "interpreter framework", "simulation", "prototype", "enterprise application", "documentation"] ,
modifiedTime: "2025-11-07T17:20:18.647Z",
publishedTime: "2025-11-07T17:20:18.647Z"
    }
  };
};